export var DOCUMENT_TYPE;
(function (DOCUMENT_TYPE) {
    DOCUMENT_TYPE["ADDENDUM"] = "ADDENDUM";
    DOCUMENT_TYPE["CO_BORROWER_FORM"] = "CO_BORROWER_FORM";
    DOCUMENT_TYPE["AADHAAR_CARD"] = "AADHAAR_CARD";
    DOCUMENT_TYPE["PAN_CARD"] = "PAN_CARD";
    DOCUMENT_TYPE["ECS_MANDATE"] = "ECS_MANDATE";
})(DOCUMENT_TYPE || (DOCUMENT_TYPE = {}));
